import {
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_VIEWER,
  PERMISSION_CANTILEVER_SINGAPORE_MEMBER,
  PERMISSION_GECKO_INTERNAL_MEMBER,
  type RolodexPermissionsValues,
} from 'types'

export const ASSET_OVERVIEW_VIEW_PERMISSIONS: RolodexPermissionsValues[] = [
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_VIEWER,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN,
  PERMISSION_GECKO_INTERNAL_MEMBER,
  PERMISSION_CANTILEVER_SINGAPORE_MEMBER,
]
